import React, { useState } from "react";
import "./Navigation.css"; // Import the CSS file for styling
import Logo from "../assets/fleur-logo-white-2-no-background.png"

// -------------------------------
// Top Navigation Component
// -------------------------------
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="nav-container">
      {/* LOGO */}
      <div className="nav-logo">
        <img
          src={Logo}
          alt="Logo"
          className="nav-logo-img"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        />
      </div>

      {/* DESKTOP LINKS */}
      <ul className="nav-links">
        <li><a href="#hero">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#gallery">Gallery</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact" className="nav-contact-btn">Contact</a></li>
      </ul>

      {/* MOBILE HAMBURGER */}
      <div className="nav-hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <a onClick={() => setIsOpen(false)} href="#hero">Home</a>
        <a onClick={() => setIsOpen(false)} href="#about">About</a>
        <a onClick={() => setIsOpen(false)} href="#services">Services</a>
        <a onClick={() => setIsOpen(false)} href="#gallery">Gallery</a>
        <a onClick={() => setIsOpen(false)} href="#testimonials">Testimonials</a>
        <a onClick={() => setIsOpen(false)} href="#contact" className="mobile-contact-btn">Contact</a>
      </div>
    </nav>
  );
};

export default Navigation;
